/**
 * @generated SignedSource<<cc9bfeddf0fb0e68509323eb315ea941>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivityVisibility = "AUTHENTICATED" | "MEMBERS" | "UNAUTHENTICATED";
export type UpdateEventInput = {
  banner?: any | null | undefined;
  description?: string | null | undefined;
  rules?: string | null | undefined;
  shortDescription?: string | null | undefined;
  slug?: string | null | undefined;
  thumbnail?: any | null | undefined;
  title?: string | null | undefined;
  visibility?: ActivityVisibility | null | undefined;
};
export type EventOverviewPageUpdateEventMutation$variables = {
  id: string;
  input: UpdateEventInput;
};
export type EventOverviewPageUpdateEventMutation$data = {
  readonly updateEvent: {
    readonly node: {
      readonly description: string | null | undefined;
      readonly id: string;
    };
  };
};
export type EventOverviewPageUpdateEventMutation = {
  response: EventOverviewPageUpdateEventMutation$data;
  variables: EventOverviewPageUpdateEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "updateEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventOverviewPageUpdateEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventOverviewPageUpdateEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c1567e15fe875fd1f365dbabf221e960",
    "id": null,
    "metadata": {},
    "name": "EventOverviewPageUpdateEventMutation",
    "operationKind": "mutation",
    "text": "mutation EventOverviewPageUpdateEventMutation(\n  $id: ID!\n  $input: UpdateEventInput!\n) {\n  updateEvent(id: $id, input: $input) {\n    node {\n      id\n      description\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e25e10a4da6ca6093e33623d74e52f1";

export default node;
